import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import compact from 'lodash/compact';
import MainImage from '~/components/atoms/Editorial/MainImage.vue';
import { getImageUrl } from '~/helpers/image-helper';
export default {
  name: 'ProductItemWebForm',
  components: {
    MainImage
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    productPrice() {
      return this.product.total || this.product.price;
    },

    currentPrice() {
      return this.productPrice.sales.amount ? this.productPrice.sales.formatted : this.productPrice.base.formatted;
    },

    currentEcoPart() {
      return this.productPrice.eco.formatted ? this.productPrice.eco.formatted : this.productPrice.eco.amount;
    },

    formattedName() {
      return compact([this.product.line ? this.product.line.toUpperCase() : null, this.product.name, this.product.quantitySet > 1 ? this.$t('lot', {
        x: this.product.quantitySet
      }) : null]).join(' - ');
    }

  }),
  methods: {
    getImage(product) {
      return getImageUrl(product);
    },

    formatPrice(priceStr) {
      if (Number.isNaN(Number(priceStr))) {
        return priceStr;
      }

      return new Intl.NumberFormat(this.locale.iso, {
        style: 'currency',
        currency: this.locale.currency
      }).format(priceStr);
    }

  }
};